"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MaterialTabs = class MaterialTabs extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    closeButton;
    onClose_button(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("closeButton");
    }
    tabManager;
    onTab_manager(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("tabManager");
    }
    noContentWrapper;
    onNo_content_wrapper(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("noContentWrapper");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    get contentClass() {
        if (this.loaded) {
            return this.noContentWrapper
                ? 'flex-fill overflow-hidden h-100'
                : 'flex-fill overflow-auto px-3 py-4 h-100 bg-page';
        }
        return null;
    }
    async act_7315092382398562_emit_2448_getActionArgs($event) {
        return {
            event: "input",
            value: {
                tabIndex: $event.originalEvent,
            },
        };
    }
    async act_7315092382398562_script_2450_getActionArgs_value($event) {
        this.tabManager.visited($event.originalEvent, true);
    }
    async act_7315092382398562_script_2450_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_2450_getActionArgs_value($event),
        };
    }
    async act_7315092382398562_script_2450_getWhen($event) {
        return !!this.tabManager;
    }
    async act_7315092382398562_script_2452_getActionArgs_value($event) {
        this.$root.$emit('slickgrid:resize', { resetScrollPosition: true });
    }
    async act_7315092382398562_script_2452_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_2452_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_input(event, scope) {
        return await this.actions.evh_7315092382398562_input.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_emit_2454_getActionArgs($event) {
        return {
            event: "close",
        };
    }
    async evh_1548630417156826_click(event, scope) {
        return await this.actions.evh_1548630417156826_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_emit_2448 = new core_1.actions.EmitAction({
            actionArgs: this.act_7315092382398562_emit_2448_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_input_2447 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_emit_2448,
            event: "input",
            displayName: "emit",
        });
        const act_7315092382398562_script_2450 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_2450_getActionArgs,
            when: this.act_7315092382398562_script_2450_getWhen,
            events: [],
        });
        const evh_7315092382398562_input_2449 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_2450,
            event: "input",
            displayName: "script",
        });
        const act_7315092382398562_script_2452 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_2452_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_input_2451 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_2452,
            event: "input",
            displayName: "script",
        });
        const evh_7315092382398562_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_input_2447, evh_7315092382398562_input_2449, evh_7315092382398562_input_2451],
        });
        const act_1548630417156826_emit_2454 = new core_1.actions.EmitAction({
            actionArgs: this.act_1548630417156826_emit_2454_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_click_2453 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_emit_2454,
            event: "click",
            displayName: "emit",
        });
        const evh_1548630417156826_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_click_2453],
        });
        return {
            act_7315092382398562_emit_2448,
            evh_7315092382398562_input_2447,
            act_7315092382398562_script_2450,
            evh_7315092382398562_input_2449,
            act_7315092382398562_script_2452,
            evh_7315092382398562_input_2451,
            evh_7315092382398562_input,
            act_1548630417156826_emit_2454,
            evh_1548630417156826_click_2453,
            evh_1548630417156826_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], MaterialTabs.prototype, "closeButton", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('closeButton'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MaterialTabs.prototype, "onClose_button", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], MaterialTabs.prototype, "tabManager", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('tabManager'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MaterialTabs.prototype, "onTab_manager", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], MaterialTabs.prototype, "noContentWrapper", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('noContentWrapper'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MaterialTabs.prototype, "onNo_content_wrapper", null);
MaterialTabs = __decorate([
    (0, vue_property_decorator_1.Component)()
], MaterialTabs);
exports.default = MaterialTabs;
vue_property_decorator_1.Vue.component("MaterialTabs", MaterialTabs);
